import { IModelBase } from "@pmis3/core";
import { IEditFlagBaseObject } from "libs/vessel-activity/vessel-activity-core/src/lib/vessel-visit/model/edit-flag";

export interface IOrganization extends IModelBase {
    name?: string;
    phone?: string;
    email?: string;
    organizationTypeIds?: number[];
    organizationTypes?: IOrganizationType[];
}

export interface IOrganizationType {
    organizationTypeId: number;
    organizationTypeName: string;
}

export interface IOrganizationTypeOrganization {
    organization: IOrganization;
    organizationType: IOrganizationType;
}

export interface IOrganizationEdit extends IEditFlagBaseObject, IModelBase {
    organizationId: number;
    organizationTypeId: number;
}

export interface IVesselVisitOrganization extends IOrganizationEdit {
    vesselVisitId: number;
}

export interface IVesselStopOrganization extends IOrganizationTypeOrganization {
    vesselStopId: number;
}

export interface IVesselOrganization extends IOrganizationTypeOrganization {
    vesselId: number;
}

export enum OrganizationTypeNameEnum {
    Tug = 'Towing Service',
    Launch = 'Launch Service',
}
